// extracted by mini-css-extract-plugin
export default {"blurred":"PriceDisplay_blurred__7p-S6"};